var _g, _g2, _text, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBespoke(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#B05FFD",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#7B2CBF",
      stopOpacity: 1
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(250, 200)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 40,
    fill: "url(#grad2)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -10,
    y: -70,
    width: 20,
    height: 30,
    rx: 3,
    fill: "url(#grad2)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -10,
    y: 40,
    width: 20,
    height: 30,
    rx: 3,
    fill: "url(#grad2)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -70,
    y: -10,
    width: 30,
    height: 20,
    rx: 3,
    fill: "url(#grad2)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: -10,
    width: 30,
    height: 20,
    rx: 3,
    fill: "url(#grad2)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: -55,
    width: 20,
    height: 30,
    rx: 3,
    fill: "url(#grad2)",
    transform: "rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -55,
    y: 35,
    width: 20,
    height: 30,
    rx: 3,
    fill: "url(#grad2)",
    transform: "rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -55,
    y: -55,
    width: 20,
    height: 30,
    rx: 3,
    fill: "url(#grad2)",
    transform: "rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 35,
    width: 20,
    height: 30,
    rx: 3,
    fill: "url(#grad2)",
    transform: "rotate(-45)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(350, 320) rotate(-45)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -10,
    y: -80,
    width: 20,
    height: 100,
    rx: 3,
    fill: "#c0c0c0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-25 -80 Q-25 -110, 0 -110 Q25 -110, 25 -80 L15 -80 Q15 -95, 0 -95 Q-15 -95, -15 -80 Z",
    fill: "#c0c0c0"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 350,
    fontFamily: "monospace",
    fontSize: 60,
    fill: "url(#grad2)",
    opacity: 0.6
  }, "&lt;/&gt;")), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(120, 150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L40 0 L40 15 Q55 15, 55 30 Q55 45, 40 45 L40 60 L0 60 L0 45 Q-15 45, -15 30 Q-15 15, 0 15 Z",
    fill: "#e0e0e0"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(160, 150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L40 0 L40 15 Q55 15, 55 30 Q55 45, 40 45 L40 60 L0 60 L0 45 Q15 45, 15 30 Q15 15, 0 15 Z",
    fill: "url(#grad2)",
    opacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBespoke);
export default __webpack_public_path__ + "static/media/bespoke.702362fe927d885b96a6a1ad9f084ac2.svg";
export { ForwardRef as ReactComponent };